import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  categorytoEdit: "",
  popoverId: "",
  popoverIdTracker: "",
  expandedCategories: [],
  categoryToDelete: null,
  popoverFooterTracker: false,
  expandedMonthColumnsByContext: {},
};

const slice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setOpenPopover: (state, action) => {
      state.popoverId = action.payload;
    },
    setPopOverIdTracker: (state, action) => {
      state.popoverIdTracker = action.payload;
    },
    setOpenTableFooter: (state, action) => {
      state.popoverFooterTracker = action.payload;
    },
    closeAllexpandedCategories: (state, { payload }) => {
      state.expandedCategories = [];
    },
    expandCategories: (state, { payload }) => {
      if (payload.key) {
        const index = state.expandedCategories.indexOf(payload.key);
        if (index !== -1) {
          state.expandedCategories.splice(index, 1);
        } else {
          state.expandedCategories.push(payload.key);
        }
      }
    },
    openDeleteDialog: (state, { payload }) => {
      state.categoryToDelete = payload;
    },
    toggleExpandedMonthColumn: (state, { payload }) => {
      const { contextKey, dataIndex } = payload || {};
      if (!contextKey || !dataIndex) return;

      if (!state.expandedMonthColumnsByContext[contextKey]) {
        state.expandedMonthColumnsByContext[contextKey] = {};
      }

      const current =
        state.expandedMonthColumnsByContext[contextKey][dataIndex];
      state.expandedMonthColumnsByContext[contextKey][dataIndex] = !current;
    },
  },
  extraReducers: {},
});

export const {
  expandCategories,
  setOpenPopover,
  setOpenTableFooter,
  openDeleteDialog,
  setPopOverIdTracker,
  closeAllexpandedCategories,
  toggleExpandedMonthColumn,
} = slice.actions;
export const reducer = slice.reducer;

export default slice;
